import { render, staticRenderFns } from "./StepWatchMyStory.vue?vue&type=template&id=51ace9b9"
import script from "./StepWatchMyStory.vue?vue&type=script&lang=js"
export * from "./StepWatchMyStory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports